﻿import jquery from 'jquery';
import HabEvents from '../../Global/habitaclia-events';

//TODO [Pedro]: Este módulo está pendiente de la maquetación correcta para reescribir ciertas partes, tambien hay que ver si se debe
//tocar el html que devuelve el ASP por AJAX
class Publicidad {
    
    constructor(publicidadDTO){
        this.publicidadDTO = publicidadDTO;
        this.urlClick = publicidadDTO.urlClick;
        this.bar = jquery('.cajonalertafooter');
        this.$finsblr = jquery('.finsblr');
        this.$sblr1 = jquery('#js-sblr1');
        this.$sblr2 = jquery('#js-sblr2');
        this.__loadPublicidad();
        

    }

    __loadPublicidad(){
        //TODO [Pedro] revisar en el ASP si es necesario pasar los parámetros del formulario además del parámetro P
        jquery.ajax({
            url: this.publicidadDTO.urlPublicidad,
            type: 'POST',
            data: 'p=' + this.publicidadDTO.dataPublicidad,
            dataType: 'json',
            success: (data) => {
                this.__mostrarPublicidad(data);
                this.__posicionarBar();
            },
                
            error:  (jqXHR, textStatus, errorThrown) => {
                this.__ocultarSBLR1();
                this.__ocultarSBLR2();
                const msg = `Error MostrarPublicidad carga en segundo plano: responseText: ${jqXHR.responseText} textStatus: ${textStatus} errorThrown: ${errorThrown}`;
                throw msg;
            }
        });
    }


    __posicionarBar(){
        if (this.$finsblr.length > 0){

            const offset = this.$finsblr.offset();

            if (offset !== undefined){
                const top = offset.top;
                this.bar.css({ 'top': top, 'position' : 'absolute' });
            }
        }
    }

    __mostrarPublicidad(data) {
        const row1 = data.filter(slot => slot.position < 6);
        const row2 = data.filter(slot => slot.position >= 6);

        if (row1.length > 0) {
            this.$sblr1.html(row1.map(slot => this.__buildSlotHtml(slot)).join(''));
            this.__ocultarAlertas();
        } else {
            this.__ocultarSBLR1();
        }

        if (row2.length > 0) {
            this.$sblr2.html(row2.map(slot => this.__buildSlotHtml(slot)).join(''));
        } else {
            this.__ocultarSBLR2();
        }

        this.__loadImagesPublicidad();
        this.__bindClickHandlers(this.$sblr1);
        this.__bindClickHandlers(this.$sblr2);
        jquery.publish(HabEvents.EventsEnum.LogosCargados);
    }

    __buildSlotHtml(slot) {
        const isContracted = slot.campaignId && slot.bannerId;
        const pixelGif = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';

        return `<li>
            <a class="gtmpromotionview gtmclickpromo"
               data-gtmid="${slot.gtm.id}"
               data-gtmname="${slot.gtm.name}"
               data-gtmcreative="${slot.gtm.creative}"
               data-gtmposition="${slot.position}"
               data-agency-id="${isContracted ? slot.agencyId : ''}"
               data-campaign-id="${isContracted ? slot.campaignId : ''}"
               data-banner-id="${isContracted ? slot.bannerId : ''}"
               data-destination-url="${isContracted ? '' : slot.destinationUrl}"
               title="${slot.altText}"
               href="#"
               target="_blank"
               rel="nofollow">
                <img class="loadImg"
                     name="${slot.imageUrl}"
                     src="${pixelGif}"
                     border="0"
                     height="60"
                     width="120"
                     alt="${slot.altText}" />
            </a>
        </li>`;
    }

    __bindClickHandlers(container) {
        container.on('click', '.gtmclickpromo', async (e) => {
            e.preventDefault();
            const $el = jquery(e.currentTarget);
            const destinationUrl = $el.data('destination-url');

            if (destinationUrl) {
                window.open(destinationUrl, '_blank');
                return;
            }

            const agencyId = $el.data('agency-id');
            const campaignId = $el.data('campaign-id');
            const bannerId = $el.data('banner-id');

            const response = await fetch(
                `${this.urlClick}?agencyId=${agencyId}&campaignId=${campaignId}&bannerId=${bannerId}`
            );
            const data = await response.json();

            if (data.url) {
                window.open(data.url, '_blank');
            }
        });
    }

    __ocultarAlertas(){
        setTimeout(function () {
            const listainmueblesleftHeight = jquery('.listainmueblesleft').height();
            const filtrosHeight = jquery('.filtros').height();
            const cajanalertaFooterHeight = jquery('.cajonalertafooter').height();
            const alertarsHeaderNHeight = (jquery('#alertaslistaheaderN').length > 0 ? jquery('#alertaslistaheaderN').height() : 0);
            const sblrHeight = (jquery('.sblr1').length > 0 ? jquery('.sblr1').height() : 0);
            const $cajonAlertaFooter = jquery('.cajonalertafooter');

            if (listainmueblesleftHeight < filtrosHeight + cajanalertaFooterHeight + alertarsHeaderNHeight + sblrHeight) {
                $cajonAlertaFooter.removeClass('mostrar').addClass('ocultar');
            } else {
                $cajonAlertaFooter.removeClass('ocultar').addClass('mostrar');
            }

        }, 3000);
    }

    __ocultarSBLR1() {
        jquery('.sblr.sblr1').remove();
    }

    __ocultarSBLR2(){
        jquery('.sblr.sblr2').remove();
    }

    __loadImagesPublicidad() {
        jquery('#js-sblr1 .loadImg').each((index, element) => {
            if (element.name.length > 0) {
                element.src = element.name;
                element.name = '';
            }
        });

        jquery('#js-sblr2 .loadImg').each((index, element) => {
            if (element.name.length > 0) {
                element.src = element.name;
                element.name = '';
            }
        });
    }

}

export default Publicidad;
